import React from 'react';

import * as ST from './styled';

interface IProps {
    description: string,
    rowCount?: number,
}

const EquipmentDescription = ({
    description = '',
    rowCount = 4,
} : IProps): JSX.Element => {
    return (
        <ST.Text
            maxRows={rowCount}
            dangerouslySetInnerHTML={{ __html: description }}
            $smaller={true}
        />
    );
};

export default React.memo(EquipmentDescription);
